import React from 'react';
import { css } from '@emotion/css';
import { Button } from '../../../../shared/ui/button/button';
import type { ButtonProps } from '../../../../shared/ui/button/button';

const baseLoginButtonStyle = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '48px',
  borderRadius: 'var(--spacing-sm)',
  fontSize: 'var(--fs-400)',
  fontWeight: 600,
  fontFamily: 'Montserrat',
  padding: '0 var(--spacing-md)',
  width: '100%',
  '@media (max-width: 920px)': {
    minHeight: '44px',
    fontSize: 'var(--fs-350)',
  },
});

export const BaseLoginButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, children, ...rest }, ref) => {
    return (
      <Button ref={ref} className={`${baseLoginButtonStyle} ${className || ''}`} {...rest}>
        {children}
      </Button>
    );
  }
);

BaseLoginButton.displayName = 'BaseLoginButton';
